import { render, staticRenderFns } from "./CashbackCpfBlock.vue?vue&type=template&id=76801722"
import script from "./CashbackCpfBlock.vue?vue&type=script&lang=js"
export * from "./CashbackCpfBlock.vue?vue&type=script&lang=js"
import style0 from "./CashbackCpfBlock.vue?vue&type=style&index=0&id=76801722&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports